import { Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import Input from "../../../../components/common/inputs/Input";
import Select from "../../../../components/common/inputs/Select";
import Button from "../../../../components/common/button/Button";
import Table from "../../../../components/common/table/Table";
import ImagesModal from "../../../../components/common/modals/imgaes-modal/ImagesModal";
import { fileUrl } from "../../../../services/config";
import CurrencyInput from "../../../../components/common/inputs/CurrencyInput";
import { warningMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import { productOptionsValidation } from "../../../../utils/validations/prodcut/productOptionsValidation";
import { variationOptionsColumns } from "../../../../constant/tablesColumns/tablesColums";

const { forwardRef, useRef, useImperativeHandle } = React;

const ProductOption = forwardRef(({ optionData, handleOption, productSku }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {
      setVariation(null);
      setName("");
      setDiscountType("price");
      setVariations([]);
      setImage("");
      setInheritSalesValue("");
    },
  }));

  const [variation, setVariation] = useState(null);
  const [name, setName] = useState("");
  const [discountType, setDiscountType] = useState("price");
  const [variations, setVariations] = useState([]);
  const [inheritSalesValue, setInheritSalesValue] = useState("");

  const formHandler = async (values, { resetForm }) => {
    values["image"] = image || "";
    values["discountType"] = discountType;
    values["discount"] = Number(values.discount) || 0;
    values["price"] = Number(values.price) || 0;
    values["stock"] = Number(values.stock) || 0;
    values["buyPrice"] = Number(values.buyPrice) || 0;
    values["weight"] = values.weight !== "" ? Number(values.weight) : undefined;
    if (!values?._id) {
      delete values["_id"];
    }

    if (
      discountType !== "percent" ||
      (discountType == "percent" && values.discount <= 100)
    ) {
      if (!variation) {
        setVariations((prevState) => [...prevState, values]);
        reset();
      } else {
        const newVariations = variations.filter(
          (item) => item.value != variation.value
        );
        setVariations([...newVariations, values]);
        setVariation(null);
        reset();
      }
      setImage("");
      setDiscountType("price");
      resetForm();
    } else {
      warningMessage("درصد تخفیف نمیتواند بیشتر از 100 باشد");
    }
  };

  const onDelete = (data) => {
    const newOptions = variations.filter((item) => item.value != data.value);
    setVariations(newOptions);
  };
  const onEdit = (data) => {
    setVariation(data);
    setDiscountType(data.discountType);
    setImage(data.image || "");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNewVariations = () => {
    if (name?.length && variations?.length) {
      const finalVariations = variations.map((v) => {
        if (inheritSalesValue && v.value === inheritSalesValue) {
          return { ...v, legacySku: productSku };
        }
        const { legacySku: _, ...rest } = v;
        return rest;
      });
      handleOption({
        name: name,
        variations: finalVariations,
      });
      setVariation(null);
      // setVariations([]);
      setImage("");
      setShowModal(false);
    } else if (!variations?.length) {
      setShowModal(false);
      handleOption(null);
    } else {
      warningMessage("لطفا نام آپشن را وارد کنید.");
    }
  };
  useEffect(() => {
    if (optionData?.variations?.length > 0) {
      let newVariations = optionData?.variations.map((item) => {
        item["discount"] =
          item.discountType == "percent"
            ? item.discountPercent
            : item.discountPrice;
        return item;
      });

      setVariations(newVariations);
      setName(optionData?.name);

      const legacyVar = newVariations.find((v) => v.legacySku);
      if (legacyVar) setInheritSalesValue(legacyVar.value);
    } else {
      setVariations([]);
      setName("");
      setInheritSalesValue("");
    }
  }, [optionData]);

  const imagesModal = useRef();
  const [image, setImage] = useState("");

  const columns = useMemo(
    () =>
      variationOptionsColumns.map((column) =>
        column.value === "image"
          ? {
              ...column,
              render: (row) =>
                row.image ? (
                  <img
                    src={`${fileUrl}files/thumb_${row.image}`}
                    className="w-12 h-12 rounded-lg object-cover"
                    alt=""
                  />
                ) : (
                  <span className="text-gray-400">—</span>
                ),
            }
          : column
      ),
    []
  );

  const selectedImages = (item) => {
    setImage(item.name);
  };

  const discountRef = useRef();
  const priceRef = useRef();
  const buyPriceRef = useRef();

  const reset = () => {
    discountRef.current.afterSubmit();
    priceRef.current.afterSubmit();
    buyPriceRef.current.afterSubmit();
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-full h-full overflow-y-scroll  bg-white dark:bg-gray-900 shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0"
        }`}
      >
        <div className="flex w-full items-center justify-between dark:text-white">
          <h4>افزودن آپشن</h4>
          <Button
            onClick={handleNewVariations}
            type="button"
            color="primary"
            text="بازگشت"
          />
        </div>
        <div className="flex my-4">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            name="name"
            placeholder="نام آپشن"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>

        <h4 className=" dark:text-white">اضافه کردن ویژگی</h4>
        <Formik
          enableReinitialize
          initialValues={{
            inventoryStatus: variation?.inventoryStatus || "available",
            value: variation?.value || "",
            price: variation?.price || "",
            buyPrice: variation?.buyPrice || "",
            image: variation?.image || "",
            stock: variation?.stock || "",
            desc: variation?.desc || "",
            checkStock: variation?.checkStock || false,
            discount: variation?.discount || "",
            sku: variation?.sku || "",
            _id: variation?._id || "",
            weight: variation?.weight ?? "",
          }}
          validationSchema={productOptionsValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="grid gap-6 my-4 md:grid-cols-2">
                <Input
                  name={"value"}
                  placeholder="مقدار"
                  label="مقدار"
                  type="text"
                />
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت
                  </label>
                  <CurrencyInput
                    placeholder="قیمت"
                    ref={priceRef}
                    name="price"
                    inputValue={formik.values["price"]}
                    onChange={(e) => formik.setFieldValue("price", e)}
                  />
                  {formik.errors.price && formik.touched.price ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.price}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت خرید
                  </label>
                  <CurrencyInput
                    placeholder="قیمت خرید"
                    ref={buyPriceRef}
                    name="buyPrice"
                    inputValue={formik.values["buyPrice"]}
                    onChange={(e) => formik.setFieldValue("buyPrice", e)}
                  />
                  {formik.errors.buyPrice && formik.touched.buyPrice ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.buyPrice}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    نوع تخفیف
                  </label>
                  <select
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value={"percent"}>درصد</option>
                    <option value={"price"}>قیمت</option>
                  </select>
                </div>

                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    تخفیف
                  </label>
                  <CurrencyInput
                    placeholder="تخفیف"
                    name="discount"
                    ref={discountRef}
                    inputValue={formik.values["discount"]}
                    onChange={(e) => formik.setFieldValue("discount", e)}
                  />
                  {formik.errors.discount && formik.touched.discount ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.discount}
                    </p>
                  ) : null}
                </div>

                <Select
                  name="inventoryStatus"
                  placeholder="موجودی"
                  label="موجودی"
                >
                  <option value={"available"}>موجود</option>
                  <option value={"unavailable"}>نا موجود</option>
                </Select>
                <Input
                  name="stock"
                  placeholder="موجودی انبار"
                  label="موجودی انبار"
                  type="text"
                />
                <Input
                  name={"desc"}
                  placeholder="توضیحات"
                  label="توضیحات"
                  type="text"
                />
                <Input
                  name={"weight"}
                  placeholder="وزن (گرم)"
                  label="وزن (گرم)"
                  type="number"
                />
                <Input
                  name={"sku"}
                  placeholder="شناسه یکتا"
                  label="شناسه یکتا"
                  type="text"
                />
                <Select
                  name="checkStock"
                  value={formik.values["checkStock"] ? "true" : "false"}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "checkStock",
                      e.target.value === "true"
                    );
                  }}
                  placeholder="بررسی موجودی انبار"
                  label="بررسی موجودی انبار"
                >
                  <option value="true">بله</option>
                  <option value="false">خیر</option>
                </Select>
                <div className="md:col-span-2">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    عکس اختصاصی آپشن (اختیاری)
                  </label>
                  <div className="flex items-center justify-between">
                    <div className="flex gap-2">
                      {image && (
                        <img
                          src={`${fileUrl}files/thumb_${image}`}
                          className="w-16 h-16 rounded-lg"
                          alt=""
                        />
                      )}
                      {/* <p className="max-w-12 overflow-hidden">{image || ""}</p> */}
                    </div>
                    <div className="flex gap-2">
                      {image && (
                        <Button
                          type="button"
                          onClick={() => setImage("")}
                          text={"حذف"}
                          color={"danger"}
                        />
                      )}

                      <Button
                        type="button"
                        onClick={() => imagesModal.current.showModal()}
                        text={image ? "ویرایش" : "انتخاب"}
                        color={"success"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-2 flex gap-x-3">
                {variation && (
                  <Button
                    type="button"
                    onClick={() => setVariation(null)}
                    text={"بازگشت"}
                    color={"danger"}
                  />
                )}
                <Button
                  text={variation ? "ویرایش" : "افزون"}
                  color={"primary"}
                />
              </div>
            </Form>
          )}
        </Formik>

        <Table
          columns={columns}
          rows={variations}
          onEdit={onEdit}
          onDelete={onDelete}
          notFoundMessage="شما هنوز هیچ ویژگی اضافه نکرده اید"
        />

        {productSku && variations.length > 0 && variations.every((v) => !v.legacySku) && (
          <div className="mt-4 p-4 rounded-xl border border-yellow-400 bg-yellow-50 dark:bg-yellow-900/20 dark:border-yellow-600">
            <p className="text-sm font-medium text-yellow-800 dark:text-yellow-300 mb-2">
              انتقال آمار فروش قبلی
            </p>
            <p className="text-xs text-yellow-700 dark:text-yellow-400 mb-3">
              این محصول قبلاً بدون آپشن بوده. آمار فروش گذشته را به کدام آپشن منتقل کنیم؟
            </p>
            <select
              value={inheritSalesValue}
              onChange={(e) => setInheritSalesValue(e.target.value)}
              className="bg-white border border-yellow-400 text-gray-900 text-sm rounded-lg focus:ring-yellow-500 focus:border-yellow-500 block w-full p-2.5 dark:bg-gray-700 dark:border-yellow-600 dark:text-white"
            >
              <option value="">انتقال نده</option>
              {variations.map((v) => (
                <option key={v.value} value={v.value}>
                  {v.value}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
    </>
  );
});
export default ProductOption;
